export default __webpack_public_path__ + "static/media/1.2f1dd7b0.jpg";